<div class="rcp-info-box" [class]="color()">
  <div class="info-box-content">
    <div class="info-box-text-container">
      @if (icon()) {
        <div class="info-box-icon">
          <fa-icon [icon]="icon()" />
        </div>
      }
      <div class="info-box-text">
        @if (title()) {
          <span class="info-box-title">{{ title() }}</span>
        }
        <ng-content />
      </div>
    </div>

    <div class="info-box-actions">
      <ng-content select="[actions]" />
    </div>
  </div>

  @let infoBoxDismissableIdConst = infoBoxDismissableId();
  @if (infoBoxDismissableIdConst) {
    <rcp-text-link-action (click)="dismiss(infoBoxDismissableIdConst, $event)">
      {{ 'qz-don-t-show-again-zm' | translate }}
    </rcp-text-link-action>
  }
</div>
